// Spec: docs/spec/auth/SPEC-auth-department-user-review-removal-A.yaml#login-flow-has-no-department-branch
import { useCallback } from 'react'

const useLoginSuccessFlow = () => {
  const onCheckAuthFlow = useCallback((onSuccess?: () => void) => {
    if (onSuccess) {
      onSuccess()
    }
  }, [])

  return {
    onCheckAuthFlow,
  }
}

export default useLoginSuccessFlow
